import '../styles/search.css'
import React, { useEffect, useState, useCallback, useRef } from 'react'
import * as XLSX from 'xlsx'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { Container, Row, Col, Spinner } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import Select from 'react-select'
import Header from '../components/Header'
import Header2 from '../components/Header2'
import PreFooter from '../components/PreFooter'
import Footer from '../components/Footer'
import SearchCard from '../components/SearchCard'
import SideResponsiveOpen from '../components/SideResponsiveOpen'
import ViewerModal from '../components/ViewerModal'
import SideBar from '../components/SideBar'

import {
  getAreas,
  getTopics,
  getIndicators,
  getCountries,
  getCards,
  saveSearch,
  getGlobalTopSearch,
} from '../actions/searchActions'
import Message from '../components/Message'
import { SEARCH_CARDS_RESET } from '../constants/searchConstants'


const useQuery = () => {
  return new URLSearchParams(useLocation().search);
}

function SearchScreen() {
  const query = useQuery();

  const topic = query.get('topic');
  const indicator = query.get('indicator');

  const dispatch = useDispatch()
  const navigate = useNavigate()
  // dispatch({type: 'INDICATOR_RESET_LIST'})


  const [sortOption, setSortOption] = useState('relevance')
  const [topicValue, setTopicValue] = useState(null)
  const [indicatorValue, setIndicatorValue] = useState(null)
  const [countryValue, setCountryValue] = useState(null)

  const [finalList, setFinalList] = useState(null)
  const [downloadingAll, setDownloadingAll] = useState(false)
  const [indicatorFrequencies, setIndicatorFrequencies] = useState({}) // Guardar frecuencias por indicador
  const indicatorFrequenciesRef = useRef({}) // Referencia para evitar problemas de closure

  const [cardPage, setCardPage] = useState(1)

  // Estado para la fecha de actualización más reciente (desde el backend)
  const [latestUpdateDate, setLatestUpdateDate] = useState(null)
  const [lastUpdateFormatted, setLastUpdateFormatted] = useState('September 26, 2025')

  // Cargar la fecha de última actualización desde el backend
  useEffect(() => {
    const fetchLastUpdate = async () => {
      try {
        const { data } = await axios.get('/api/v1/data/last-update/')
        if (data.formatted) {
          setLastUpdateFormatted(data.formatted)
        }
        if (data.last_update) {
          setLatestUpdateDate(new Date(data.last_update))
        }
      } catch (error) {
        console.log('Error fetching last update:', error)
      }
    }
    fetchLastUpdate()
  }, [])

  // Mantener la referencia sincronizada con el estado
  useEffect(() => {
    indicatorFrequenciesRef.current = indicatorFrequencies;
    console.log('🔄 Referencia de frecuencias actualizada:', indicatorFrequencies);
  }, [indicatorFrequencies]);

  // Función para filtrar elementos con datos válidos (muy básica)
  const filterValidCards = (dataList) => {
    if (!dataList || !Array.isArray(dataList)) return []

    return dataList.filter(item => {
      // Verificación mínima: que el item exista y tenga las propiedades básicas
      return item &&
        item.group &&
        item.data &&
        item.group.indicator &&
        item.group.units &&
        item.group.units.length > 0
    })
  }

  useEffect(() => {
    // if (typeof window.trackPageVisit === 'function') {
    //   window.trackPageVisit('Search');
    // }

    // console.log("Using LMW-provisional database in postgresql")
    // const loadData = async () => {
    // await dispatch(resetSearch())
    dispatch({
      type: SEARCH_CARDS_RESET,
    })
    dispatch(getGlobalTopSearch())
    dispatch(getAreas())
    dispatch(getTopics())
    dispatch(getIndicators())
    dispatch(getCountries())
    // }
    // loadData()

  }, [dispatch])

  const userLogin = useSelector(state => state.userLogin)
  const { loading: loadingLogin, error: errorLogin, userInfo } = userLogin


  const areaInfo = useSelector(state => state.areaList)
  const { loading, error, areaList } = areaInfo

  const topicInfo = useSelector(state => state.topicList)
  const { loading: loadingTopic, error: errorTopic, topicList } = topicInfo

  const indicatorInfo = useSelector(state => state.indicatorList)
  const { loading: loadingIndicator, error: errorIndicator, indicatorList } = indicatorInfo

  const globalInfo = useSelector(state => state.globalTopSearch)
  const { loading: loadingGlobal, error: errorGlobal, list } = globalInfo

  useEffect(() => {
    if (topic && topic !== '' && topicList && topicList.length > 0) {
      const topicItem = topicList.find(item => item.id == topic)
      if (topicItem) {
        const topicOption = [{ api: topicItem.name, area: topicItem.foreign_area, label: topicItem.beauty_name, value: topicItem.id }]
        setTopicValue(topicOption)
      }
    }
  }, [topic, topicList])

  useEffect(() => {
    if (indicator && indicator !== '' && indicatorList && indicatorList.length > 0) {
      const indicatorItem = [...indicatorList].find(item => item.id == indicator)
      if (indicatorItem) {
        const indicatorOption = [{ api: indicatorItem.name, area: indicatorItem.foreign_area, label: indicatorItem.name, topic: indicatorItem.foreign_topic, value: indicatorItem.id }]
        setIndicatorValue(indicatorOption)
      }
    }
  }, [indicator, indicatorList])



  const countryInfo = useSelector(state => state.countryList)
  const { loading: loadingCountry, error: errorCountry, countryList } = countryInfo





  const cardInfo = useSelector(state => state.cardList)
  const { loading: loadingCard, error: errorCard, cardList } = cardInfo

  useEffect(() => {
    console.log("CARDLIST changed: ", cardList)
    if (cardList && cardList.data_list && Array.isArray(cardList.data_list)) {
      // Hacer copia profunda para no mutar el estado original de Redux
      const newFinalList = JSON.parse(JSON.stringify(cardList));
      console.log("Setting finalList with data_list length: ", newFinalList.data_list.length)
      setFinalList(newFinalList);

      // Inicializar frecuencias de cada indicador
      const frequencies = {};
      newFinalList.data_list.forEach(item => {
        if (item.group && item.group.indicator) {
          frequencies[item.group.indicator] = item.group.frequency;
        }
      });
      setIndicatorFrequencies(frequencies);

      // Obtener la fecha de actualización más reciente de todos los indicadores
      let mostRecentDate = null;
      newFinalList.data_list.forEach(item => {
        if (item.group && item.group.updated) {
          const updateDate = new Date(item.group.updated);
          if (!mostRecentDate || updateDate > mostRecentDate) {
            mostRecentDate = updateDate;
          }
        }
      });
      setLatestUpdateDate(mostRecentDate);
    } else if (!cardList || Object.keys(cardList).length === 0) {
      // Si cardList es undefined o un objeto vacío (después de reset), limpiar finalList
      console.log("cardList is empty/undefined, clearing finalList")
      setFinalList(null)
      setIndicatorFrequencies({})
      setLatestUpdateDate(null)
    }
  }, [cardList])



  // ************ select options

  // Mostrar todos los topics agrupados por área
  const areas = [...new Set(topicList?.map(item => item.foreign_area))]

  const topicOptions = areas?.map(item => {
    // Filtrar topics de esta área y ordenar alfabéticamente
    const areaTopics = topicList
      .filter(element => element.foreign_area === item)
      .sort((a, b) => {
        const nameA = a.name.split('_')[1] || a.name
        const nameB = b.name.split('_')[1] || b.name
        return nameA.localeCompare(nameB)
      })

    return {
      label: areaList?.filter(element => element.id === item)[0]?.name.split('_')[1],
      options: areaTopics.map(element => {
        return {
          value: element.id,
          label: element.name.split('_')[1],
          area: element.foreign_area,
          api: element.name
        }
      })
    }
  })

  // Mostrar indicadores ordenados: primero los de topics seleccionados, luego el resto
  const topics = [...new Set(indicatorList?.map(item => item.foreign_topic))]

  // Obtener IDs de topics seleccionados
  const selectedTopicIds = topicValue ? topicValue.map(t => t.value) : []

  // Separar topics seleccionados y no seleccionados
  const selectedTopics = topics.filter(topicId => selectedTopicIds.includes(topicId))
  const unselectedTopics = topics.filter(topicId => !selectedTopicIds.includes(topicId))

  // Ordenar: primero topics seleccionados, luego el resto
  const orderedTopics = [...selectedTopics, ...unselectedTopics]

  const indicatorOptions = orderedTopics?.map(item => {
    const topicName = topicList?.filter(element => element.id === item)[0]?.name.split('_')[1]
    const isSelectedTopic = selectedTopicIds.includes(item)

    // Filtrar indicadores de este topic y ordenar alfabéticamente
    const topicIndicators = indicatorList
      .filter(element => element.foreign_topic === item)
      .sort((a, b) => a.name.localeCompare(b.name))

    return {
      label: isSelectedTopic ? `✓ ${topicName}` : topicName,
      options: topicIndicators.map(element => {
        return {
          value: element.id,
          label: element.name,
          area: element.foreign_area,
          topic: element.foreign_topic,
          api: element.name
        }
      })
    }
  })

  const countryOptions = countryList?.map(item => {
    return {
      value: item.id,
      label: item.name,
    }
  })

  // Opción para seleccionar todos los países
  const selectAllCountriesOption = {
    value: 'select-all',
    label: 'Select All Countries'
  }

  // Agregar la opción de "Select All" al inicio de las opciones de países
  const countryOptionsWithSelectAll = countryOptions ? [selectAllCountriesOption, ...countryOptions] : []


  const sortHandler = (option) => {
    setSortOption(option)
    if (option === 'title') {
      setFinalList(prevState => ({
        ...prevState,
        data_list: [...finalList.data_list].sort((a, b) => a.group.indicator.localeCompare(b.group.indicator))
      }))

    }
  }

  const searchHandler = useCallback(async () => {
    // Validar que se haya seleccionado al menos un país
    if (!countryValue || countryValue.length === 0) {
      return
    }

    // Limpiar estado local inmediatamente
    setFinalList(null)
    setCardPage(1)

    let topic = (topicValue ? topicValue.map(item => {
      return item.api
    }) : [])
    let indicator = (indicatorValue ? indicatorValue.map(item => {
      return item.api
    }) : [])
    let country = (countryValue ? countryValue.map(item => {
      return item.label
    }) : [])

    // Lógica de validación: Si se envía un indicador, no enviar topic
    if (indicator && indicator.length > 0) {
      topic = []
    }

    // Dispatch reset y luego la nueva búsqueda
    dispatch({
      type: SEARCH_CARDS_RESET,
    })

    dispatch(saveSearch(
      null, // area ya no se usa
      topicValue ? topicValue.map(item => item.value) : [],
      indicatorValue ? indicatorValue.map(item => item.value) : [],
      null, // region ya no se usa
      countryValue ? countryValue.map(item => item.value) : [],
      null, // frequency ya no se usa
      // Nombres como fallback
      topicValue ? topicValue.map(item => item.api || item.label) : [],
      indicatorValue ? indicatorValue.map(item => item.label) : [],
      countryValue ? countryValue.map(item => item.label) : []
    ))

    dispatch(getCards('', topic, indicator, country, ''))
  }, [topicValue, indicatorValue, countryValue, dispatch])

  // Este useEffect SOLO se ejecuta cuando hay topic o indicator en la URL (deep link)
  // NO debe ejecutarse cuando el usuario cambia los selectores manualmente
  useEffect(() => {
    if (topicList && indicatorList && (topic || indicator)) {
      // Solo ejecutar si hay países seleccionados
      if (countryValue && countryValue.length > 0) {
        searchHandler()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topicList, indicatorList, topic, indicator]) // Removido searchHandler de las dependencias

  const resetHandler = () => {
    setTopicValue(null)
    setIndicatorValue(null)
    setCountryValue(null)

    dispatch({
      type: SEARCH_CARDS_RESET,
    })
  }

  const topicHandler = (option) => {
    if (option.length === 0) {
      setTopicValue(null)
      // Si se quitan todos los topics, también quitar indicadores que no pertenezcan a ningún topic seleccionado
      setIndicatorValue(null)
    } else {
      setTopicValue(option)

      // Filtrar indicadores para mantener solo los que pertenecen a los topics seleccionados
      if (indicatorValue && indicatorValue.length > 0) {
        const selectedTopicIds = option.map(t => t.value)
        const filteredIndicators = indicatorValue.filter(ind =>
          selectedTopicIds.includes(ind.topic)
        )
        setIndicatorValue(filteredIndicators.length > 0 ? filteredIndicators : null)
      }
    }
  }

  const indicatorHandler = (option) => {
    if (option.length === 0) {
      setIndicatorValue(null)
      return
    }

    // Obtener los topics de los indicadores seleccionados
    const indicatorTopics = option.map(ind => ind.topic)
    const uniqueTopicIds = [...new Set(indicatorTopics)]

    // Crear array de topics basado en los indicadores seleccionados
    const newTopics = uniqueTopicIds.map(topicId => {
      const topicData = topicList?.find(t => t.id === topicId)
      if (topicData) {
        return {
          value: topicData.id,
          label: topicData.name.split('_')[1],
          area: topicData.foreign_area,
          api: topicData.name
        }
      }
      return null
    }).filter(t => t !== null)

    // Actualizar indicadores
    setIndicatorValue(option)

    // Actualizar topics automáticamente para reflejar los topics de los indicadores seleccionados
    setTopicValue(newTopics.length > 0 ? newTopics : null)
  }
  const countryHandler = (option) => {
    // Verificar si se seleccionó "Select All Countries"
    const selectAllSelected = option?.some(opt => opt.value === 'select-all')
    
    if (selectAllSelected) {
      // Si se selecciona "Select All", agregar todos los países (excepto la opción "Select All")
      setCountryValue(countryOptions)
    } else {
      setCountryValue(option)
    }
  }

  const loadMoreHandler = () => {
    setCardPage(cardPage + 1)
  }

  const popularSearchHandler = (item) => {
    var topic = item.topic_id
    var indicator = item.indicator_id
    window.location.href = `${window.location.origin}/#/search?topic=${encodeURIComponent(topic)}&indicator=${encodeURIComponent(indicator)}`
    window.location.reload(); // Forzar recarga de la página
  }

  const downloadAllHandler = async () => {
    if (!finalList || !finalList.data_list || downloadingAll) return

    const validCards = filterValidCards(finalList.data_list).slice(0, 4 * cardPage)

    if (validCards.length === 0) return

    setDownloadingAll(true)

    console.log('🚀 Iniciando descarga de todos los indicadores');
    console.log('📊 Estado actual de frecuencias:', indicatorFrequenciesRef.current);

    try {
      // Crear un workbook con múltiples hojas
      const workbook = XLSX.utils.book_new()

      // Obtener los países seleccionados por el usuario
      const selectedCountries = countryValue ? countryValue.map(item => item.label) : []

      // Procesar cada indicador de forma secuencial para obtener TODOS los datos
      for (let index = 0; index < validCards.length; index++) {
        const item = validCards[index]
        const { group: meta, data } = item

        // Obtener la frecuencia actual del estado (que se actualiza cuando el usuario cambia la frecuencia)
        // Si no existe en el estado, usar la frecuencia por defecto del meta
        // Usamos .current para obtener el valor más reciente y evitar problemas de closure
        const currentFrequency = indicatorFrequenciesRef.current[meta.indicator] || meta.frequency

        console.log(`📥 Descargando "${meta.indicator}" con frecuencia: ${currentFrequency}`,
          `(Estado: ${indicatorFrequenciesRef.current[meta.indicator]}, Default: ${meta.frequency})`);
        try {
          // Hacer una solicitud individual para cada indicador con TODOS los países seleccionados
          const config = {
            headers: {
              'Content-type': 'application/json'
            }
          }

          const { data: response } = await axios.post(
            '/api/v1/data/change-card-data/',
            {
              topic: meta.topic,
              indicator: meta.indicator,
              country: selectedCountries,
              unit: '',
              frequency: currentFrequency,
            },
            config
          )

          // El backend devuelve { data_dict: [...], Message: "Success" }
          const fullData = response.data_dict || []

          console.log(`📦 Datos recibidos para ${meta.indicator}:`, fullData.length, 'registros');

          // Filtrar datos por la frecuencia actual de la tarjeta
          const filteredData = fullData.filter(dataItem =>
            dataItem.frequency.toLowerCase().trim() === currentFrequency.toLowerCase().trim()
          )

          // Si no hay datos con la frecuencia correcta, usar todos los datos
          const dataToUse = filteredData.length > 0 ? filteredData : fullData

          console.log(`Descargando ${meta.indicator}: ${dataToUse.length} registros con frecuencia ${currentFrequency}`)

          // Preparar los datos para este indicador
          // Usar 'year' de la nueva DB, con fallback a 'period' para compatibilidad
          const sortData = dataToUse.map(dataItem => ({
            indicator: meta.indicator,
            country: dataItem.country,
            frequency: dataItem.frequency,
            year: dataItem.year || dataItem.period || '',
            date: dataItem.date,
            unit: dataItem.unit,
            definition: dataItem.definition,
            source: dataItem.source,
            value: dataItem.value,
            transformation: dataItem.transformation || '',
            notes: dataItem.notes || ''
          }))

          // Crear worksheet para este indicador
          const worksheet = XLSX.utils.json_to_sheet(sortData)

          // Nombre de la hoja (limitado a 31 caracteres para Excel)
          let sheetName = meta.indicator.substring(0, 31)
          if (sheetName.length === 31) {
            sheetName = sheetName.substring(0, 28) + '...'
          }

          // Asegurar que el nombre de la hoja sea único
          let finalSheetName = sheetName
          let counter = 1
          while (workbook.SheetNames.includes(finalSheetName)) {
            const suffix = `_${counter}`
            finalSheetName = sheetName.substring(0, 31 - suffix.length) + suffix
            counter++
          }

          XLSX.utils.book_append_sheet(workbook, worksheet, finalSheetName)
        } catch (error) {
          console.error(`Error descargando datos para ${meta.indicator}:`, error)
          // Si falla, usar los datos que ya tenemos en memoria
          const { data } = item
          const sortData = data.map(dataItem => ({
            indicator: meta.indicator,
            country: dataItem.country,
            frequency: dataItem.frequency,
            year: dataItem.year || dataItem.period || '',
            date: dataItem.date,
            unit: dataItem.unit,
            definition: dataItem.definition,
            source: dataItem.source,
            value: dataItem.value,
            transformation: dataItem.transformation || '',
            notes: dataItem.notes || ''
          }))

          const worksheet = XLSX.utils.json_to_sheet(sortData)
          let sheetName = meta.indicator.substring(0, 31)
          if (sheetName.length === 31) {
            sheetName = sheetName.substring(0, 28) + '...'
          }

          let finalSheetName = sheetName
          let counter = 1
          while (workbook.SheetNames.includes(finalSheetName)) {
            const suffix = `_${counter}`
            finalSheetName = sheetName.substring(0, 31 - suffix.length) + suffix
            counter++
          }

          XLSX.utils.book_append_sheet(workbook, worksheet, finalSheetName)
        }
      }

      // Generar nombre del archivo
      const timestamp = new Date().toISOString().split('T')[0]
      const fileName = `All_Indicators_${timestamp}.xlsx`

      // Descargar el archivo
      XLSX.writeFile(workbook, fileName)
    } catch (error) {
      console.error('Error en la descarga:', error)
    } finally {
      setDownloadingAll(false)
    }
  }



  return (
    <div>
      {userInfo ? (
        <Header2 />
      ) : (
        <Header />
      )}

      <div className='d-flex'>
        {userInfo && (
          <SideBar />
        )}
        <div style={{ flex: '1' }} className='search-main-container'>
          <h1 style={{ color: '#303950' }} className='search-title text-center pt-5'>LATIN MACRO WATCH - FISLAC DATASET</h1>
          <p className='comment text-center'>
            Updated on {lastUpdateFormatted}
          </p>

          <Container className='little-p'>
            Popular search terms:
          </Container>
          <div style={{ backgroundColor: '#F6F6F6' }} className='w-100'>
            <Container className='popular-container'>
              {loadingGlobal && (
                <Spinner animation="border" as={'span'} style={{ width: '20px', height: '20px' }} />
              )}

              {list && list.slice(0, 5).map((item, index) => (
                <div key={index} onClick={e => popularSearchHandler(item)} className='popular-term'>{item.indicator}</div>
              ))}

            </Container>
          </div>
          <Container fluid='md'>
            <Row>
              <Col className='search-params-container' md={5}>
                <p className='search-label'>Topic:</p>
                <Select
                  className='mb-3'
                  classNamePrefix="search-select"
                  isMulti
                  options={topicOptions}
                  placeholder={'Select topic'}
                  value={topicValue}
                  onChange={option => topicHandler(option)}
                />

                <p className='search-label'>Indicator:</p>
                <Select
                  className='mb-3'
                  classNamePrefix="search-select"
                  isMulti
                  options={indicatorOptions}
                  placeholder={'Select indicator'}
                  value={indicatorValue}
                  onChange={option => indicatorHandler(option)}
                />

                <p className='search-label'>Country: <span style={{ color: 'red' }}>*</span></p>
                <Select
                  className='mb-3'
                  classNamePrefix="search-select"
                  isMulti
                  options={countryOptionsWithSelectAll}
                  placeholder={'Select countries (required)'}
                  value={countryValue}
                  onChange={option => countryHandler(option)}
                />


                <div className='py-5'>
                  <button
                    onClick={searchHandler}
                    className='search-button me-4'
                    disabled={(!topicValue && !indicatorValue) || !countryValue || countryValue.length === 0}
                  >
                    Search
                  </button>
                  <button onClick={resetHandler} className='search-button'>Reset</button>
                </div>
              </Col>
              <Col className='search-card-container' md={7}>
                {finalList && filterValidCards(finalList.data_list).length > 0 && (
                  <div className='d-flex justify-content-center pt-4 pb-3'>
                    <button onClick={downloadAllHandler} className='search-button' disabled={downloadingAll}>
                      {downloadingAll ? (
                        <>
                          <Spinner animation="border" as={'span'} size="sm" className='me-2' />
                          Downloading...
                        </>
                      ) : (
                        <>
                          <i className="fa-solid fa-download pe-2"></i>
                          Download All ({filterValidCards(finalList.data_list).slice(0, 4 * cardPage).length} indicators)
                        </>
                      )}
                    </button>
                  </div>
                )}

                {loadingCard ? (
                  // <Loader />
                  <div className='h-100 d-flex align-items-center justify-content-center'>
                    <Spinner animation="border" as={'span'} style={{ width: '20px', height: '20px' }} />
                  </div>
                ) : error ? (
                  <Message variant={'danger'}>{error}</Message>
                ) : finalList && finalList.data_list ? filterValidCards(finalList.data_list)
                  .slice(0, 4 * cardPage)
                  .map((item, index) => (
                    <SearchCard
                      key={index}
                      meta={item.group}
                      data={item.data}
                      countries={countryValue}
                      onFrequencyChange={(indicator, frequency) => {
                        console.log(`🔄 Cambiando frecuencia de "${indicator}" a "${frequency}"`);
                        setIndicatorFrequencies(prev => {
                          const updated = {
                            ...prev,
                            [indicator]: frequency
                          };
                          console.log('📊 Estado de frecuencias actualizado:', updated);
                          return updated;
                        });
                      }}
                    />
                  )) : (
                  <div className='p-5 d-flex flex-column align-items-center justify-content-center h-100'>
                    <img src="/static/empty-search.svg" style={{ width: '15em' }} className='py-5 opacity-75' alt='' />
                    <p style={{ fontSize: '15px' }} className='text-center'>Select criteria from the drop-down lists and click <b>'Search'</b> to begin. At least one Topic or Indicator and at least one Country are required.</p>
                  </div>
                )}

                {finalList != null && (cardPage * 4 < filterValidCards(finalList.data_list).length) && (
                  <div className='d-flex justify-content-center pt-5'>
                    <button onClick={loadMoreHandler} className='search-button'>Load More</button>
                  </div>
                )}

              </Col>
            </Row>

          </Container>

          <br /><br /><br />

        </div>

      </div>

      <SideResponsiveOpen />
      <PreFooter />
      <Footer />
    </div>
  )
}

export default SearchScreen
